import { Injectable, NgModule } from '@angular/core';
import { Observable } from 'rxjs';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from '@environments/environment';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(private router: Router, private toastrService: ToastrService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('bearerToken');
    const forgeryToken = localStorage.getItem('forgeryToken');
    const baseUrl = environment.apiUrl;

    // Skip i18n requests
    if (req.url.lastIndexOf('i18n') > -1) {
      return next.handle(req);
    }

    const url = req.url.lastIndexOf('api') > -1 ? req.url : 'api/' + req.url;

    if (token) {
      // Build headers object
      let headers = req.headers.set('Authorization', 'Bearer ' + token);

      // Add forgery token if available
      if (forgeryToken) {
        headers = headers.set('X-CSRF-TOKEN', forgeryToken);
      }

      const newReq = req.clone({
        headers: headers,
        url: `${baseUrl}${url}`,
      });

      return next.handle(newReq).pipe(
        tap(
          () => { },
          (err: any) => {
            if (err instanceof HttpErrorResponse) {
              if (err.status === 401) {
                // Clear tokens on 401
                this.router.navigate(['login']);
              } else if (err.error) {
                let errorMsg = err.error;
                if (Array.isArray(errorMsg) && errorMsg.length > 0) {
                  errorMsg = errorMsg[0];
                }
                if (typeof errorMsg === 'string' && (errorMsg.includes('Invalid InteractionId Status Closed') || errorMsg.includes('Status Closed'))) {
                  errorMsg = 'Ticket already Closed';
                }
                this.toastrService.error(errorMsg);
              } else {
                this.toastrService.error(err.message, '', {
                  enableHtml: true,
                });
              }
            }
          }
        )
      );
    } else {
      // No bearer token - still add forgery token if available
      let headers = req.headers;
      if (forgeryToken) {
        headers = headers.set('X-CSRF-TOKEN', forgeryToken);
      }

      const newReq = req.clone({
        headers: headers,
        url: `${baseUrl}${url}`,
      });

      return next.handle(newReq).pipe(
        tap(
          () => { },
          (err: any) => {
            if (err instanceof HttpErrorResponse) {
              if (err.status === 401 || err.status === 403) {
                localStorage.removeItem('authObj');
                localStorage.removeItem('bearerToken');
                localStorage.removeItem('forgeryToken');
                this.router.navigate(['login']);
              }
              if (err.status === 409) {
                this.toastrService.error(err.error.messages[0]);
              }
            }
          }
        )
      );
    }
  }
}

@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true,
    },
  ],
})
export class HttpInterceptorModule { }
